/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { removeShoppingCartItem } from "action/shopping-cart/removeShoppingCartItem";
import { updateItem } from "action/shopping-cart/updateItem";
import { setProductDeliveryDetails } from "action/utils/setProductDeliveryDetails";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { getProductDeliveryDetailsSkuApi } from "api/product/getProductDeliveryDetailsSkuApi";
import PAImage from "component/design-system/images/PAImage";
import ProductQuantityDropdown from "component/design-system/product-quantitiy/ProductQuantityDropdown";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import RemoveItem from "component/product/RemoveItem";
import { RootState } from "interfaces/generics.type";
import { IOrderedItemView } from "interfaces/session/ShoppingCart";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { currency } from "util/helper/currency";
import { isEmpty } from "util/lodash/isEmpty";
import { getThumbnailSrcV2 } from "util/product/getThumbmailSrc";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import styles from "./CartSummary.module.scss";
// import headerStyles from "./headerAccountTop.module.scss";

function EachItem(props) {
  const { product } = props;
  const dispatch = useDispatch();
  const router = useRouter();
  const { locale } = router;
  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const { postalCode } = useSelector((store: RootState) => store.shoppingCart);

  const updateDeliveryDetails = () => {
    if (PRODUCT_PAGE_TYPES.includes(currentPageType)) {
      getProductDeliveryDetailsSkuApi(product.sku, postalCode, 1)
        .then(({ data }) => {
          const { productDeliveryDetails } = data;
          dispatch(setProductDeliveryDetails(productDeliveryDetails.availableDeliveryMethodsDetails));
        });
    }
  };

  function handleUpdateItem(each: ICompactProduct, quantity: any) {
    const quantityValue = isEmpty(quantity) ? 1 : quantity;
    dispatch(updateItem(each, quantityValue, updateDeliveryDetails));
  }

  return (
    <div className="d-flex align-items-center justify-content-center flex-column m-t-5 m-b-5">
      <PAImage
        src={getThumbnailSrcV2(product)}
        width={80}
        height={80}
        alt={product.longDescription}
      />
      <PAText component="span" color="black" bold fontSize={FONT_SIZE[0]} className="p-t-10">
        {currency(product.price, locale)}
      </PAText>
      <div
        style={{ width: "100%" }}
        className={`${styles.vertical_line} ${styles.actions} d-flex justify-content-between p-t-10 p-b-10`}
        onClick={(e) => e.preventDefault()}
      >
        <ProductQuantityDropdown
          item={product}
          handleUpdateItem={handleUpdateItem}
        />
        <RemoveItem
          product={product}
          onRemove={() => {
            dispatch(removeShoppingCartItem(product))
              .then(() => {
                updateDeliveryDetails();
              });
          }}
        />
      </div>
    </div>
  );
}

function CartSummary() {
  const userCart = useSelector((state: RootState) => state.shoppingCart);
  const availableItems = userCart.availableItems.filter((item: IOrderedItemView) => !item.core);
  const { t } = useTranslation("common");
  const { subtotalWithDiscountDetails } = userCart;
  const { subtotalWithDiscount } = subtotalWithDiscountDetails;
  const router = useRouter();
  const { locale } = router;

  return (
    <div
      // className={headerStyles.header_account_top_container}
      style={{ width: 125 }}
    >
      <div className="d-flex flex-column">
        <HideIf show={availableItems.length === 0}>
          <PAText component="span" color="grey" fontSize={FONT_SIZE[0]}>
            {t("Your cart is empty.")}
          </PAText>
        </HideIf>

        <HideIf show={availableItems.length > 0}>
          <PAText component="span" color="grey" fontSize={FONT_SIZE[0]}>
            {t("Subtotal")}
          </PAText>
          <PAText component="span" color="black" fontSize={FONT_SIZE[1]} bold className="p-b-10">
            {currency(subtotalWithDiscount, locale)}
          </PAText>
          <div className={styles.vertical_line} />
          <div>
            {
              availableItems.map((eachItem: IOrderedItemView, index: number) => (
                <EachItem
                  product={eachItem}
                  key={index}
                />
              ))
            }
          </div>
        </HideIf>
      </div>
    </div>
  );
}

export default CartSummary;
